module.exports = __webpack_public_path__ + "img/draggable.2f5bd1d7.svg";